import { CardContent, Grid, TextField, Typography } from '@mui/material';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import TypePaperSvg from '../../svg/typePaper.svg';
// import UseOldPaperSvg from '../../svg/colorFile.svg';
import UploadPaperSvg from '../../svg/uploadPaper.svg';
import CheckHollowIcon from '../../svg/CheckHollowIcon';
import palette from '../../theme/palette';

const useStyles = makeStyles({
  cardContainer: {
    border: `1px solid ${palette.grey[400]}`,
    backgroundColor: 'white',
    borderRadius: '16px',
    cursor: 'pointer'
  },
  boxSelected: {
    borderColor: palette.secondary.main
  },
  contentStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    position: 'relative'
  },
  contentText: {
    marginTop: 15
  },
  checkIconStyle: {
    position: 'absolute',
    top: 10,
    right: 10
  }
});

const ChoseType = forwardRef(({ handleNext, testName, testType }, ref) => {
  const classes = useStyles();
  const [name, setTestName] = useState(testName);
  const [selectedType, setSelectedType] = useState(testType);

  const [testNameErr, setNameErr] = useState(false);

  const isValid = () => {
    const nameErr = name.trim() !== '';
    setNameErr(name.trim() === '');

    return nameErr;
  };

  useImperativeHandle(ref, () => ({
    handleChoseType() {
      if (isValid()) {
        handleNext(name, selectedType);
      }
    }
  }));

  return (
    <div style={{ marginTop: 25 }}>
      <TextField
        fullWidth
        margin="dense"
        label="Test Name"
        placeholder="Example: Class test, mid test..."
        value={name}
        onChange={(e) => setTestName(e.target.value)}
        error={testNameErr}
        helperText={testNameErr ? 'Test name is required' : ''}
      />
      <div style={{ marginTop: 30 }}>
        <Typography>Select Option</Typography>
        <Grid container spacing={2} style={{ marginTop: 1 }}>
          <Grid item xs={12} md={6} sm={6}>
            <div
              className={`${classes.cardContainer} ${
                selectedType === 'TYPE' ? classes.boxSelected : ''
              }`}
              role="presentation"
              onClick={() => setSelectedType('TYPE')}
            >
              <CardContent className={classes.contentStyle}>
                {selectedType === 'TYPE' && (
                  <CheckHollowIcon
                    color={palette.secondary.main}
                    className={classes.checkIconStyle}
                  />
                )}
                <img src={TypePaperSvg} alt="type-questions" />
                <Typography className={classes.contentText}>Type Question Paper</Typography>
              </CardContent>
            </div>
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <div
              className={`${classes.cardContainer} ${
                selectedType === 'UPLOAD' ? classes.boxSelected : ''
              }`}
              role="presentation"
              onClick={() => setSelectedType('UPLOAD')}
            >
              <CardContent className={classes.contentStyle}>
                {selectedType === 'UPLOAD' && (
                  <CheckHollowIcon
                    color={palette.secondary.main}
                    className={classes.checkIconStyle}
                  />
                )}
                <img src={UploadPaperSvg} alt="upload-paper" />
                <Typography className={classes.contentText}>Upload Question Paper</Typography>
              </CardContent>
            </div>
          </Grid>
          {/* <Grid item xs={12} md={4} sm={4}>
            <div
              className={`${classes.cardContainer} ${
                selectedType === 'OLD_PAPER' ? classes.boxSelected : ''
              }`}
              role="presentation"
              onClick={() => setSelectedType('OLD_PAPER')}
            >
              <CardContent className={classes.contentStyle}>
                {selectedType === 'OLD_PAPER' && (
                  <CheckHollowIcon
                    color={palette.secondary.main}
                    className={classes.checkIconStyle}
                  />
                )}
                <img src={UseOldPaperSvg} alt="use-old-paper" />
                <Typography className={classes.contentText}>Use Older Paper</Typography>
              </CardContent>
            </div>
          </Grid> */}
        </Grid>
      </div>
    </div>
  );
});

ChoseType.propTypes = {
  handleNext: PropTypes.func,
  testName: PropTypes.string,
  testType: PropTypes.string
};

export default ChoseType;
